<template>
  <div class="animated fadeIn ventas-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes renglones-descripcion" 
                :busy="tableBusy"
                :items="renglonesDescripcion"
                :fields="fields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(descripcion)="data">
                  <input 
                    type="text"
                    v-model="data.item.descripcion"
                    @input="validarRenglonDescripcion()"/>
              </template>
              <template v-slot:cell(importe)="data">
                  <input 
                    type="text"
                    v-model="data.item.importe"
                    @input="validarRenglonDescripcion()"/>
              </template>
            </b-table>
            <div class="add-table-btn">
              <div class="list-add-btn" @click.prevent="agregarRenglonDescripcion">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </div>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
const { mapFields } = createHelpers({
  getterType: 'venta/getField',
  mutationType: 'venta/updateField',
});

export default {
  name: 'ABM',
  components: {
  },
  data () {
    return {
      fields: [
        {
          key: 'descripcion',
        },
        { 
          key: 'importe', 
          class: "text-right" 
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'renglonesDescripcion',
    ]),
  },  
  created() {
  },
  activated() {
    this.$emit('can-continue', { value: true });
  },
  methods: {
    agregarRenglonDescripcion() {
      this.$store.dispatch('venta/addRenglonDescripcion')
        .then(() => {
          this.$emit('can-continue', { value: true });
        })
    },
    validarRenglonDescripcion() {
      this.$store.dispatch('venta/validarRenglonDescripcion')
        .then(() => {
          this.$emit('can-continue', { value: true });
        })
    }
  },
}
</script>

<style>
  .ventas-abm .renglones-descripcion table td[aria-colindex="1"] input {
    text-align: left;
  }
</style>
